import { Framework } from '@/framework/instance';
import { IEditMessage } from '../../types';
import { OperateType } from '../../types/operate';
import { Room } from '../room';

/**
 * 自定义消息
 */
export class CustomMessage extends Framework {
    constructor(
        identity: string,
        private room: Room,
    ) {
        super(identity);
        this.room.onMessage(OperateType.CustomEvent, this.onReceiveCustomEvent.bind(this));
    }

    private customEventName = '_ot-custom-event';

    /** 发送选中图层事件 */
    sendToAll(message: any) {
        this.room.sendToAll(OperateType.CustomEvent, [message]);
    }

    onToAllMessage(cb: (message: any) => void) {
        return this.framework.events.on(this.customEventName, cb);
    }

    /** 收到选中图层事件回调 */
    private onReceiveCustomEvent({ data }: IEditMessage<any[]>) {
        const [message] = data;
        this.framework.events.emit(this.customEventName, message);
    }
}
